// extracted by mini-css-extract-plugin
export default {"checkBoxMainBox":"style_checkBoxMainBox__gOdKf","input":"style_input__M0w-F","label":"style_label__sPyjT","labelText":"style_labelText__ZFAR7","sublabel":"style_sublabel__ApLca"};